import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ShoppingBag } from 'lucide-react';
import { useRestaurantCart } from '../happyspace-restaurant-sdk';
import { BRAND_NAME, LOGO_URL } from '../config/brand';

export default function Navbar() {
  const { itemCount } = useRestaurantCart();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white/95 backdrop-blur-md shadow-sm sticky top-0 z-50 border-b border-orange-100/50" data-hs-id="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <img 
                src={LOGO_URL} 
                alt={`${BRAND_NAME} Logo`} 
                className="h-16 w-auto object-contain"
                data-hs-id="nav-logo"
              />
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-[#D97706] font-medium">Home</Link>
            <Link to="/menu" className="text-gray-700 hover:text-[#D97706] font-medium">Menu</Link>
            <Link to="/locations" className="text-gray-700 hover:text-[#D97706] font-medium">Locations</Link>
            <Link to="/checkout" className="relative p-2 text-gray-700 hover:text-[#D97706]">
              <ShoppingBag className="w-6 h-6" />
              {itemCount > 0 && (
                <span className="absolute top-0 right-0 bg-[#D97706] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-bold">
                  {itemCount}
                </span>
              )}
            </Link>
            <Link to="/menu" className="bg-[#D97706] text-white px-6 py-2 rounded-full font-bold hover:bg-[#B45309] transition-colors">
              Order Now
            </Link>
          </div>

          <div className="md:hidden flex items-center gap-4">
            <Link to="/checkout" className="relative p-2 text-gray-700">
              <ShoppingBag className="w-6 h-6" />
              {itemCount > 0 && (
                <span className="absolute top-0 right-0 bg-[#D97706] text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
                  {itemCount}
                </span>
              )}
            </Link>
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700">
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 py-4 px-4 space-y-4">
          <Link to="/" onClick={() => setIsOpen(false)} className="block text-gray-700 font-medium">Home</Link>
          <Link to="/menu" onClick={() => setIsOpen(false)} className="block text-gray-700 font-medium">Menu</Link>
          <Link to="/locations" onClick={() => setIsOpen(false)} className="block text-gray-700 font-medium">Locations</Link>
          <Link to="/menu" onClick={() => setIsOpen(false)} className="block bg-[#D97706] text-white text-center py-3 rounded-lg font-bold">Order Now</Link>
        </div>
      )}
    </nav>
  );
}